import { render, staticRenderFns } from "./HighlightNumber.vue?vue&type=template&id=07578e31&"
import script from "./HighlightNumber.vue?vue&type=script&lang=js&"
export * from "./HighlightNumber.vue?vue&type=script&lang=js&"
import style0 from "./HighlightNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports